import { render, staticRenderFns } from "./DeliveryEstimate.vue?vue&type=template&id=716ea094&scoped=true&"
import script from "./DeliveryEstimate.vue?vue&type=script&lang=js&"
export * from "./DeliveryEstimate.vue?vue&type=script&lang=js&"
import style0 from "./DeliveryEstimate.vue?vue&type=style&index=0&id=716ea094&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "716ea094",
  null
  
)

export default component.exports